import type { SVGProps } from "react";
import { Scale } from "lucide-react";

export function UmpireAssistantIcon(props: SVGProps<SVGSVGElement>) {
  return <Scale color="currentColor" {...props} className={`w-6 h-6 ${props.className ?? ""}`} />;
}
